import { useEffect, useRef } from 'react';
import { io, Socket } from 'socket.io-client';
import { SOCKET_URL } from '../constants/apiConfig';

interface UseCallOutCalendarSocketOptions {
  enabled?: boolean;
  onUpdated?: (data: any) => void;
}

export function useCallOutCalendarSocket({
  enabled = false,
  onUpdated
}: UseCallOutCalendarSocketOptions) {
  const socketRef = useRef<Socket | null>(null);
  const callbacksRef = useRef({
    onUpdated
  });

  useEffect(() => {
    callbacksRef.current = { onUpdated };
  });

  useEffect(() => {
    if (!enabled) return;

    const socket = io(`${SOCKET_URL}/callout-calendar`, {
      transports: ['websocket'],
      withCredentials: true,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      timeout: 20000
    });

    socket.on('connect', () => {
      // eslint-disable-next-line no-console
      console.log('callout-calendar socket connected to server');
    });

    socket.on('calloutCalendarUpdated', payload => {
      if (callbacksRef.current.onUpdated) {
        callbacksRef.current.onUpdated(payload?.data ?? payload);
      }
    });

    socket.on('disconnect', () => {
      // eslint-disable-next-line no-console
      console.log('callout-calendar socket disconnected from server');
    });

    socket.on('connect_error', error => {
      // eslint-disable-next-line no-console
      console.error('Callout-calendar socket connection error:', error);
    });

    socketRef.current = socket;

    return () => {
      socket.off('calloutCalendarUpdated');
      socket.disconnect();
      socketRef.current = null;
    };
  }, [enabled]);

  return socketRef.current;
}
